import styled from 'styled-components';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  width: 100%;
`;

export const Typography = styled(TextLayoutComponent.Title)`
  text-align: center;
  margin: 40px 0 !important;
`;

export const Content = styled.div`
  padding: 10px;
  display: flex;
  justify-content: center;

  > a {
    height: 41px;
    width: 125px;

    & + a {
      margin-left: 20px;
    }
  }
`;

export const DownloadIcon = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 7px;
`;
